<template>
  <div class="activity container">
    <div class="list_box">
      <el-tabs v-model="params.status" @tab-click="handleChange">
        <el-tab-pane label="进行中" name="STARTED"></el-tab-pane>
        <el-tab-pane label="已结束" name="STOP"></el-tab-pane>
      </el-tabs>
      <el-table
        class="activities"
        :data="activities"
        height="calc(100% - 54px - 20px - 10px)"
        @row-click="goDetail"
      >
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="label"
          label="活动类型"
          width="180"
          align="center"
          :formatter="formatter"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="活动标题"
          :formatter="nameFormatter"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="endTime"
          :label="params.status == 'STARTED' ? '剩余时间' : '活动时间'"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{
              params.status == "STARTED"
                ? scope.row.autoStop
                  ? surplus(scope.row.startTime, scope.row.duration)
                  : ""
                : scope.row.startTime
            }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="goDetail(scope.row)"
              type="primary"
              plain
              size="small"
            >
              {{ params.status == "STARTED" ? "立即参加" : "查看" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { activityList } from "@/api/activity";
import { dateCount } from "@/utils/index";

export default {
  name: "activity",
  data() {
    return {
      dateCount,
      params: {
        classChapterId: this.$route.query.classChapterId,
        classId: this.$route.query.id,
        status: "STARTED",
      },
      activities: [],
      isassistant: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 活动列表
    getList() {
      this.params.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      activityList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.activities = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChange() {
      this.getList();
    },
    formatter(row) {
      if (row.type == "SIGN") {
        return "签到";
      } else if (row.type == "VOTE") {
        return "投票";
      } else if (row.type == "PICK") {
        return "选人";
      } else if (row.type == "ANSWER") {
        return "抢答";
      } else if (row.type == "DISCUSS") {
        return "主题讨论";
      } else if (row.type == "QUIZ") {
        return "随堂练习";
      } else if (row.type == "SCORE") {
        return "评分";
      }
    },
    nameFormatter(row) {
      let reg = /<\/?.+?\/?>/g;
      return row.name.replace(reg, "");
    },
    surplus(startTime, duration) {
      let end = new Date(startTime).getTime();
      duration = duration * 60 * 1000;
      end = end + duration;
      let nowTime = +new Date();
      let times = (end - nowTime) / 1000;
      if (times > 0) return dateCount(times);
    },
    goDetail({ activityId, type }) {
      this.$router.push({
        path: `/courseDetail/activity/${type.toLowerCase()}`,
        query: {
          activityId,
          ...this.$route.query,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.activity {
  height: 100%;

  .list_box {
    margin: 30px 0;
    padding: 10px 22px;
    background-color: #fff;
    height: calc(100% - 60px);
    ::v-deep .activities {
      margin-top: 10px;
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
      .el-table__row {
        cursor: pointer;
      }
    }
  }
}
</style>